/*
 * mc-shelf.js — setas do carrossel da prateleira Grafite (task 0029 · F2 · D22)
 *
 * Progressive enhancement: o track rola nativamente (overflow-x + scroll-snap);
 * este script só dá função às setas (scrollBy de 80% da largura visível —
 * padrão 0027 / home-mock:847). Listeners delegados no document → sobrevive a
 * section reload do Theme Editor. `behavior: 'auto'` sob prefers-reduced-motion
 * (skill Grafite §6). Sem libs; carregado defer pela section mc-product-shelf
 * apenas quando layout == 'carousel'.
 */
(function () {
  'use strict';

  if (window.__mcShelfInit) return;
  window.__mcShelfInit = true;

  // Gate de estado (R1): revela as setas só quando o JS está ativo.
  // visibility preserva o box → zero CLS. Sem JS a flag nunca liga e o
  // carrossel rola nativamente (overflow-x + scroll-snap).
  document.documentElement.classList.add('mc-shelf-ready');

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollShelf(button, direction) {
    var shelf = button.closest('[data-mc-shelf]');
    var track = shelf && shelf.querySelector('[data-mc-shelf-track]');
    if (!track) return;
    track.scrollBy({
      left: direction * track.clientWidth * 0.8,
      behavior: reducedMotion.matches ? 'auto' : 'smooth'
    });
  }

  document.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-mc-shelf-prev]');
    if (prev) return scrollShelf(prev, -1);
    var next = event.target.closest('[data-mc-shelf-next]');
    if (next) return scrollShelf(next, 1);
  });
})();
